export default "__VITE_ASSET__DA_95WLR__"